var map = {
	"./docs/docs.module": [
		"./src/app/pages/docs/docs.module.ts",
		"docs-docs-module"
	],
	"./front/front.module": [
		"./src/app/pages/front/front.module.ts",
		"front-front-module~perfil-perfil-module",
		"app-pages-pages-module~front-front-module",
		"front-front-module"
	],
	"./perfil/perfil.module": [
		"./src/app/pages/perfil/perfil.module.ts",
		"front-front-module~perfil-perfil-module",
		"perfil-perfil-module"
	],
	"app/extra/extra.module": [
		"./src/app/extra/extra.module.ts",
		"app-extra-extra-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"app-pages-pages-module~front-front-module",
		"app-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;